export default __webpack_public_path__ + "static/media/delete-column.ca565176.svg";